export default __webpack_public_path__ + "static/atpp-e089a33a1be6dd4b1cab5b9160172695.jpg";